import { ITenantOrganisation, IUpdateTenantOrganisationPayload } from '@pharvio/core/shared';
import { Observable } from 'rxjs';

export abstract class TenantOrganisationDataService {
  abstract getTenantOrganisation(): Observable<ITenantOrganisation>;
  abstract updateTenantOrganisation(
    payload: IUpdateTenantOrganisationPayload
  ): Observable<ITenantOrganisation>;
}
